import { module } from 'modujs';
import gsap from 'gsap';
import {$screen} from "../stores/screen.js";

export default class extends module {
    constructor(m) {
        super(m);

        this.progress = 1; // Must be one by default and not 0, in case we load the page with a scroll way below our module. This way we prevent wrong sizing on scrollup & a sudden glitch.

        // Listen for event progress if given
        this.eventProgress = this.getData('event-progress');
        this.onEventProgressBind = this.onEventProgress.bind(this);
        if(this.eventProgress) {
            window.addEventListener(this.eventProgress, this.onEventProgressBind)
        }

        this.events = {
            click: {
                'search-toggler': 'onSearchClick',
                'filters-toggler': 'onFiltersClick',
            }
        }
    }

    init() {
        this.$titleGhost = this.$('title-ghost')[0]
        this.$titleScale = this.$('title-scale')[0]

        this.el.style.setProperty('--line-breaks', this.$titleGhost.querySelectorAll('br').length);

        this.checkResizeBind = this.checkResize.bind(this)
        this.unbindScreenListener = $screen.subscribe(this.checkResizeBind)


        this.initTl();
    }

    checkResize() {
        if(!this.resizeTick) {
            this.resizeTick = true

            requestAnimationFrame(() => {
                this.initTl()

                this.resizeTick = false
            })
        }
    }

    compute() {
        this.viewport = {
            width: window.innerWidth,
            height: window.innerHeight,
        }

        this.titleScaleBCR = this.$titleScale?.getBoundingClientRect();
        this.titleGhostBCR = this.$titleGhost?.getBoundingClientRect();

        if (this.titleGhostBCR && this.titleScaleBCR) {
            this.ratio = this.titleGhostBCR.width / this.titleScaleBCR.width;
        }
    }

    reset() {
        gsap.set(this.$titleScale, { clearProps: true });
        this.tl?.kill();
        this.tl = null;
    }

    initTl() {
        this.reset();

        this.compute();

        if(this.viewport.width < 1000) return;

        this.tl?.kill();
        this.tl = gsap.timeline({});
        this.tl.to(this.$titleScale, { scale: this.ratio, force3D: true, ease: 'none' });

        this.tl.progress(this.progress);
        this.tl.pause();
    }

    onEventProgress(e) {
        this.progress = e.detail.progress
        this.el.style.setProperty('--progress', this.progress)
        this.tl?.progress?.(this.progress);
    }

    onSearchClick() {
        this.call('open', null, 'Search')
    }

    onFiltersClick() {
        this.call('open', null, 'Filters')
    }

    destroy() {
        this.unbindScreenListener?.()
        this.tl?.kill?.();

        if(this.eventProgress) {
            window.removeEventListener(this.eventProgress, this.onEventProgressBind)
        }
    }
}
